import Base from '../core/Base';

class PageProgress extends Base {
  constructor() {
    super();
    this.config = {
      selector: '.js-page-progress',
      step: '.page-progress-step',
      total: '.page-progress-total',
      activeClass: 'active',
    };
    this.state = {};
  }

  init() {
    const selector = document.querySelectorAll(this.config.selector);
    if (!this.isUnique(selector)) return;
    this.setState({
      element: selector[0],
    }, () => this.selectElements());
  }

  selectElements() {
    const { step, total } = this.config;
    const { element } = this.state;
    const list = element.querySelectorAll('ul')[0];
    const textStep = element.querySelectorAll(step)[0];
    const textTotal = element.querySelectorAll(total)[0];
    const totalPages = element.getAttribute('data-total-pages');
    const skipFirstPage = element.getAttribute('data-skip-first-page');
    const totalPagesValue = Number(totalPages);

    let skipFirstPageValue;
    if (skipFirstPage === 'true') {
      skipFirstPageValue = true;
    } else {
      skipFirstPageValue = false;
    }

    this.setState({
      list,
      textStep,
      textTotal,
      totalPages: totalPagesValue,
      skipFirstPage: skipFirstPageValue,
    }, () => this.setListenersAndStart());
  }

  setListenersAndStart() {
    window.addEventListener('hashchange', () => this.handlePageChange());
    this.setTotalPages();
    this.handlePageChange();
  }

  handlePageChange() {
    const {
      element,
      list,
      textStep,
      skipFirstPage,
    } = this.state;
    const { activeClass } = this.config;
    const currentPage = this.getCurrentPage();
    const listItems = list.querySelectorAll('li');

    for (let i = 0; i < listItems.length; i += 1) {
      const item = listItems[i];
      item.classList.remove(activeClass);
    }

    if (skipFirstPage && currentPage === 0) {
      element.style.display = 'none';
    } else {
      element.removeAttribute('style');
      this.setListItemToActive(listItems, [currentPage - 1]);
    }

    if (textStep) {
      textStep.innerHTML = currentPage;
    }
  }

  getCurrentPage() {
    const { skipFirstPage } = this.state;

    const pageNumber = window.currentpageno;

    return skipFirstPage ? pageNumber - 1 : pageNumber;
  }

  setTotalPages() {
    const { totalPages, skipFirstPage } = this.state;

    this.setState({
      totalPages: skipFirstPage ? totalPages - 1 : totalPages,
    }, () => this.renderTotalPages());
  }

  renderTotalPages() {
    const { textStep } = this.state;

    if (textStep) {
      this.renderDots();
    } else {
      this.renderBar();
    }
  }

  renderDots(){
    const { list, textTotal, totalPages } = this.state;

    for (let i = 1; i <= totalPages; i += 1) {
      const li = document.createElement('li');
      const text = document.createTextNode(i);
      li.appendChild(text);
      list.appendChild(li);
    }
    textTotal.innerHTML = totalPages;
  }

  renderBar(){
    const { list, totalPages } = this.state;

    for (let i = 1; i <= (totalPages); i += 1) {
      const li = document.createElement('li');
      const sum = Math.floor(100 / (totalPages) * i);
      li.innerHTML = `<span>${sum}%</span>`;
      list.appendChild(li);
    }
  }

  setListItemToActive(items, index) {
    const { activeClass } = this.config;
    const currentListItem = items[index];

    currentListItem.classList.add(activeClass);
  }
}

export default PageProgress;
